module.exports = __webpack_public_path__ + "img/partner_xm_05@2x.5eb7bfe3.png";